// ————————————————————————————————————————————— LIB. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— UTIL. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

import check_mediaEnabledGlobally from "../../../../../app/baseUtilities/check/check_mediaEnabledGlobally";

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

function ebh_FrontPageScroller_card_mouseEnter(ARGS) {
  // Stop, if media is disabled globally...
  if (!check_mediaEnabledGlobally()) return;

  // Setup...
  const { id: componentID } = this.options;
  const { _name, cardType, cardId } = ARGS;
  this.logger("eventbus call", [_name], "event", { inline: true });

  // If card corresponds to component (ID matches & type is »ScrollerEventCard«),
  // play video, otherwise pause...
  const cardMatchesComp = cardType === "ScrollerEventCard" && cardId === componentID;
  this.setState({ playback: cardMatchesComp ? "play" : "paused" });
}

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

export default ebh_FrontPageScroller_card_mouseEnter;
